// Beslenme öyküsü alanları — form (NutritionIntakeTab) ve PDF çıktısı ortak kullanır.

export const INTAKE_ACTIVITY = [
  { value: "sedentary", label: "Hareketsiz" },
  { value: "light", label: "Az hareketli" },
  { value: "moderate", label: "Orta" },
  { value: "active", label: "Hareketli" },
  { value: "very_active", label: "Çok hareketli" },
];

export const INTAKE_FIELDS = [
  { key: "goals", label: "Hedef ve beklenti", placeholder: "Danışanın kendi hedefi, motivasyonu" },
  { key: "mealPattern", label: "Öğün düzeni", placeholder: "Kaç öğün, atlanan öğünler, saatler" },
  { key: "eatingHabits", label: "Yeme alışkanlıkları", placeholder: "Hızlı yeme, gece yeme, dışarıda yeme, atıştırma" },
  { key: "dislikedFoods", label: "Sevmediği / yemediği", placeholder: "Sevmediği veya tüketmediği besinler" },
  { key: "intolerances", label: "İntolerans", placeholder: "Laktoz, gluten vb. hassasiyetler (alerjiler Kişisel Bilgiler'de)" },
  { key: "physicalActivity", label: "Fiziksel aktivite", placeholder: "Spor, yürüyüş, iş tipi" },
  { key: "sleep", label: "Uyku", placeholder: "Süre, düzen, kalite" },
  { key: "bowel", label: "Bağırsak düzeni", placeholder: "Sıklık, şikayetler" },
  { key: "fluids", label: "Sıvı tüketimi", placeholder: "Su, çay, kahve, içecekler" },
  { key: "alcoholSmoking", label: "Alkol / sigara", placeholder: "" },
  { key: "previousDiets", label: "Geçmiş diyetler", placeholder: "Daha önce denediği diyetler ve sonuçları" },
  { key: "note", label: "Not", placeholder: "" },
];

export const activityLabel = (v) => INTAKE_ACTIVITY.find((a) => a.value === v)?.label || "";
